import { MojoWellKnownNames } from '@common/constants/mojo-well-known-names';
import {ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable, takeUntil } from 'rxjs';
import { take, map } from 'rxjs';
import { SelectItem } from 'primeng/api';
import { PreviewModeService } from '@feature/preview-mode/services/preview-mode.service';
import { MftPreviewDialogResult } from '@feature/preview-mode/mft-preview-mode/models/mft-preview-dialog-result';
import { Store } from '@ngrx/store';
import { ApplicationState } from '@store/application-store';
import { Router } from '@angular/router';
import * as userSettingsActions from '@user-settings/actions/user-settings';
import { WellKnownRoutePaths } from '@routing/well-known-route-paths';
import { EntityKey } from '@feature/pma-entity/pma-entity-types';
import { UserAdminHttpService } from '@feature/_app_modules/mojo-for-tenants/user-admin/services/user-admin-http.service';
import { MftProductService } from '@feature/product/services/mft-product.service';
import { PmaEntityLookupHttpService } from '@feature/pma-entity/services/pma-entity-lookup-http.service';
import {OverviewService} from "@feature/overview";
import { OnDestroySubject } from '@common/components/on-destroy-subject';

@Component({
  selector: 'mojo-mft-preview-mode-dialog-container',
  templateUrl: './mft-preview-mode-dialog-container.component.html'
})
export class MftPreviewModeDialogContainerComponent
  extends OnDestroySubject
  implements OnInit {

  users: Observable<SelectItem[]>;
  tenants: Observable<SelectItem[]>;
  tenantParents: Observable<SelectItem[]>;
  showDialog: boolean;

  constructor(
    private readonly store: Store<ApplicationState>,
    private readonly router: Router,
    private readonly previewModeService: PreviewModeService,
    private readonly userAdminHttpService: UserAdminHttpService,
    private readonly pmaEntityLookupHttpService: PmaEntityLookupHttpService,
    private readonly overviewService: OverviewService) {
    super();
  }

  ngOnInit() {
  }

  onCancel() {
    this.showDialog = false;
  }

  onOk(dialogResult: MftPreviewDialogResult) {
    this.previewModeService.enterMftPreviewMode(dialogResult).pipe(
      takeUntil(this.destroy$),
      take(1)
    ).subscribe(result => {
      this.store.dispatch(new userSettingsActions.Load());
      this.overviewService.loadOverviewConfiguration();
      this.router.navigated = false;
      this.router.navigate([WellKnownRoutePaths.fromRoot(MftProductService.homeDashboard)]);
    });
    this.showDialog = false;
  }

  private getUserList(): Observable<SelectItem[]> {
    return this.userAdminHttpService.getUsers().pipe(
      takeUntil(this.destroy$),
      map((users) => {
        return users.filter(x => x.roleId != MojoWellKnownNames.RoleIds.OccupantUser).map((user) => {
          return {
            value: user.mojoPlatformUserId,
            label: user.email
          } as SelectItem;
        });
      })
    );
  }

  private getTenantList(): Observable<SelectItem[]> {
    return this.pmaEntityLookupHttpService.lookup("Tenant", "").pipe(
      takeUntil(this.destroy$),
      map((tenants) => {
      return tenants.sort((x, y) => this.sortByEntityKey(x.Key, y.Key)).map(x => {
        {
          return {
            value: x.Key,
            label: x.Name
          } as SelectItem;
        }
      });
    }));
  }

  private getTenantParentList(): Observable<SelectItem[]> {

    return this.pmaEntityLookupHttpService.lookup("TenantParent", "").pipe(
      takeUntil(this.destroy$),
      map((tenants) => {
      return tenants.sort((x, y) => this.sortByEntityKey(x.Key, y.Key)).map(x => {
        {
          return {
            value: x.Key,
            label: x.Name
          } as SelectItem;
        }
      });
    }));
  }

  doShowDialog() {
    this.users = this.getUserList();
    this.tenantParents = this.getTenantParentList();
    this.tenants = this.getTenantList();
    this.showDialog = true;
  }

  sortByEntityKey(key1: EntityKey, key2: EntityKey) {
    return key1['Ref'] - key2['Ref'];
  }
}
